import logo from './logo.svg';
import './App.css';
import Home from './pages/public/Home';
import AboutPage from './pages/public/AboutPage';
import BookingPage from './pages/public/BookingPage';
import SelectStaffPage from './pages/public/SelectStaffPage';
import SelectTimePage from './pages/public/SelectTimePage';
import ConfirmPage from './pages/public/ConfirmPage';
import BookingConfirmedPage from './pages/public/BookingConfirmedPage';
import WeeklyCalendar from './pages/public/WeeklyCalendar';
import Header from './components/Header';
import AppRouter from './AppRouter';

function App() {
  return (
    <AppRouter></AppRouter>
    
  );
}

export default App;
